"use client";

import { useEffect } from "react";

/**
 * LocaleHtmlLang Component
 *
 * Sets the lang attribute on the html element based on the current locale.
 * This ensures screen readers announce content in the correct language.
 *
 * WCAG 3.1.1 (Level A) - Language of Page
 * The default human language of each Web page can be programmatically determined.
 *
 * @param locale - The current locale (e.g., "en", "es")
 */
export default function LocaleHtmlLang({ locale }: { locale: string }) {
  useEffect(() => {
    // Set the lang attribute on the html element
    document.documentElement.lang = locale;

    // Also set the dir attribute for potential RTL support in the future
    document.documentElement.dir = "ltr";
  }, [locale]);

  // This component doesn't render anything visible
  return null;
}
